import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import type { ComponentProps, ReactNode } from "react"

import { cn } from "cn"

export type EmptyStateProps = ComponentProps<"div"> & {
  /** `null` blendet die Icon-Box aus, ausgelassen zeigt die Standard-Lupe. */
  icon?: ReactNode | null
  title: string
  description?: string
  /** z. B. ein v2 `Button` — Inhalt und Verhalten bestimmt die aufrufende Seite. */
  action?: ReactNode
}

function EmptyState({
  className,
  icon,
  title,
  description,
  action,
  ...props
}: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        "flex w-full flex-col items-center gap-3 text-center",
        className
      )}
      {...props}
    >
      {icon !== null && (
        <div
          data-slot="empty-state-icon"
          className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-neutrals-v2-200 [&_svg]:size-[22px]"
        >
          {icon ?? <FontAwesomeIcon icon={faMagnifyingGlass} />}
        </div>
      )}
      <p
        data-slot="empty-state-title"
        className="w-full text-sm leading-5 font-semibold text-labels-primary"
      >
        {title}
      </p>
      {description && (
        <p
          data-slot="empty-state-description"
          className="w-full text-sm leading-5 text-labels-secondary"
        >
          {description}
        </p>
      )}
      {action && <div data-slot="empty-state-action">{action}</div>}
    </div>
  )
}

export { EmptyState }
